import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { RktIconComponent } from '@rocketfinancialcorp/rocket-ui/icon';

import { DebitAuthorizationDetails } from '@shared/models';

/**
 * What the customer is being asked to authorize, and in which currency.
 *
 * Shown on the financial account step as well as the debit authorization step, because the currency
 * decides which accounts are usable and the customer has to know it *before* choosing one (KOR-14968).
 * Deliberately carries nothing about the financial account itself - on the earlier step there is none.
 */
@Component({
  selector: 'app-debit-authorization-summary',
  templateUrl: './debit-authorization-summary.component.html',
  styleUrls: ['./debit-authorization-summary.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [RktIconComponent],
})
export class DebitAuthorizationSummaryComponent {
  @Input() authorization?: DebitAuthorizationDetails;

  /** The agreement is dated when it is accepted, so until then the date shown is today's. */
  todayDate = new Date().toISOString().slice(0, 10);
}
